import { useState } from "react";
import { LifebuoyIcon } from "@heroicons/react/24/outline";
import emailjs from "emailjs-com";
import axios from "axios";
import { db,storage } from "../../firebase"; // Asegúrate que la ruta sea correcta
import { doc, getDoc, setDoc, updateDoc, arrayUnion, serverTimestamp,addDoc,collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";


export default function Soporte({ user }) {
  const [mensaje, setMensaje] = useState("");
  const [imagenes, setImagenes] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files).slice(0, 3);
    setImagenes(files);

    const readers = files.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readers)
      .then((base64Images) => setPreviews(base64Images))
      .catch(() => setError("Error al cargar imágenes."));
  };

  const uploadSupportImage = async (file) => {
  if (!file) throw new Error("No se seleccionó ningún archivo.");

  try {
    // Crear ruta única en Firebase Storage
    const filePath = `reportes/${Date.now()}_${file.name}`;
    const storageRef = ref(storage, filePath);

    // Subir archivo
    const snapshot = await uploadBytes(storageRef, file);

    // Obtener URL pública
    const downloadURL = await getDownloadURL(snapshot.ref);

    return downloadURL;
  } catch (error) {
    console.error("Error al subir la imagen de soporte:", error);
    throw new Error("Error al subir la imagen a Firebase Storage");
  }
};

  const handleSend = async (e) => {
  e.preventDefault();

  if (!user) {
    setError("Usuario no disponible para enviar el reporte.");
    return;
  }

  setSending(true);
  setError(null);

  try {
    // 1️⃣ Subir imágenes a storage (si hay)
    const uploadedImageUrls = imagenes.length
      ? await Promise.all(imagenes.map((img) => uploadSupportImage(img)))
      : [];

    // 2️⃣ Guardar en Firestore - colección Reports
    await addDoc(collection(db, "Reports"), {
      userId: user.uid,
      userName: user.nombre || "Anónimo",
      message: mensaje,
      imageUrls: uploadedImageUrls,
      timestamp: serverTimestamp(),
    });

    // 3️⃣ Enviar por EmailJS (opcional)
    await emailjs.send(
      "service_0gzaryb",
      "template_c0krwi4",
      {
        message: mensaje,
        reported_user_name: user.nombre || "Desconocido",
        reported_user_uid: user.uid || "Sin UID",
        timestamp: new Date().toLocaleString(),
        image_1: uploadedImageUrls[0] || "",
        image_2: uploadedImageUrls[1] || "",
        image_3: uploadedImageUrls[2] || "",
      },
      "rzHKDWT7d_ZRaDbA7"
    );

    // 4️⃣ Guardar notificación en NotificationsAdminHistory
    try {
      const notificationsRef = doc(db, "NotificationsAdminHistory", "SoporteUsuarios");
      const newNotification = {
        title: "Nuevo reporte de soporte",
        message: `${user.nombre || "Anónimo"} (${user.uid}) envió un reporte de soporte.`,
        timestamp: serverTimestamp(),
        type: "soporte_usuario",
        read: false,
        details: {
          userId: user.uid,
          userName: user.nombre || "Anónimo",
          message: mensaje,
          imageUrls: uploadedImageUrls, // siempre un array, incluso vacío
        },
      };

      const docSnap = await getDoc(notificationsRef);
      if (docSnap.exists()) {
        await updateDoc(notificationsRef, {
          notifications: arrayUnion(newNotification),
        });
      } else {
        await setDoc(notificationsRef, { notifications: [newNotification] });
      }
    } catch (notifErr) {
      console.error("Error guardando notificación de soporte:", notifErr);
    }

    // 5️⃣ Reset y feedback al usuario
    setEnviado(true);
    setMensaje("");
    setImagenes([]);
    setPreviews([]);
  } catch (err) {
    console.error("Error al enviar el soporte:", err);
    setError("Hubo un problema al enviar el reporte.");
  } finally {
    setSending(false);
  }
};



  return (
    <div className="mt-4 text-sm text-gray-700">
      <div className="flex items-center mb-4">
        <LifebuoyIcon className="h-6 w-6 text-blue-600 mr-2" />
        <h2 className="text-lg font-semibold">Soporte Técnico</h2>
      </div>

      <form onSubmit={handleSend} className="space-y-3">
        <textarea
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          placeholder="Describe el problema que estás enfrentando..."
          className="w-full border rounded p-2"
          rows={4}
          required
          disabled={sending}
        />

        {/* Subir imágenes */}
        <div>
          <label className="block font-medium mb-1 text-gray-700">
            Adjuntar hasta 3 imágenes (opcional):
          </label>

          {/* Input oculto */}
          <input
            type="file"
            accept="image/*"
            multiple
            id="fileInput"
            onChange={handleImageChange}
            disabled={sending}
            className="hidden"
          />

          {/* Botón personalizado */}
          <label
            htmlFor="fileInput"
            className={`inline-block cursor-pointer px-4 py-2 rounded bg-green-600 text-white text-sm hover:bg-gray-700 transition ${
              sending ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {sending ? "Subiendo imágenes..." : "Seleccionar imágenes"}
          </label>

          {/* Vista previa */}
          <div className="flex gap-2 mt-2 flex-wrap">
            {previews.map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`preview-${i}`}
                className="w-20 h-20 object-cover rounded border"
              />
            ))}
          </div>
        </div>

        <button
          type="submit"
          disabled={sending}
          className={`px-4 py-2 rounded text-white ${
            sending ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {sending ? "Enviando..." : "Enviar a soporte"}
        </button>
      </form>

      {enviado && (
        <p className="text-green-600 mt-2">Solicitud enviada correctamente ✅</p>
      )}
      {error && <p className="text-red-600 mt-2">{error}</p>}
    </div>
  );
}
